import { render, staticRenderFns } from "./GalleryModalTabItem.vue?vue&type=template&id=91243f56&scoped=true&"
import script from "./GalleryModalTabItem.vue?vue&type=script&lang=js&"
export * from "./GalleryModalTabItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91243f56",
  null
  
)

export default component.exports